import { trans, UNSUPPORTED_BROWSER } from '../../translator'

const showUnsupportedBrowserAlert = () => {
  const isIE = !!window.document.documentMode
  const message = trans(UNSUPPORTED_BROWSER, {}, 'authentication')

  if (isIE && message) {
    window.alert(message)
  }
}

const clearLocalState = () => {
  try {
    window.localStorage.removeItem('issue_filters')
  } catch (error) {}

  try {
    window.sessionStorage.clear()
  } catch (error) {}
}

const initLanguageDropdown = () => {
  const toggle = document.getElementById('login-language-toggle')
  const menu = document.querySelector('.dropdown-menu-language')
  const localeButtons = document.querySelectorAll('[data-locale-option]')

  if (!toggle || !menu) {
    return
  }

  const closeMenu = () => {
    menu.classList.remove('show')
    toggle.setAttribute('aria-expanded', 'false')
  }

  toggle.addEventListener('click', (event) => {
    event.preventDefault()
    const isOpen = menu.classList.contains('show')
    if (isOpen) {
      closeMenu()
      return
    }

    menu.classList.add('show')
    toggle.setAttribute('aria-expanded', 'true')
  })

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target) && event.target !== toggle && !toggle.contains(event.target)) {
      closeMenu()
    }
  })

  localeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const locale = button.getAttribute('data-locale-option')

      if (!locale) {
        return
      }

      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.set('lang', locale)
      window.location.href = currentUrl.toString()
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  showUnsupportedBrowserAlert()
  clearLocalState()
  initLanguageDropdown()
})
